// import type {DateTime} from "luxon";
// import type React from "react";
// import {z as zod} from "zod";
// import type {EratoDataTypes} from "~/components/reports/widgetSpecific/maps/widgetTypeRawDataToTransformedData";
// import type {CountryId} from "@vesta/vos-types/modules/platformLevel/geography/domain/Country";
// import type {ReportPage} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/o/$companySlug/_reportScaffold/report/edit/$reportSlug/-state";
// import type {CanvasControls} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/o/$companySlug/_reportScaffold/report/edit/$reportSlug/-types";
// import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
// import {iso8601DateTimeZodValidator, uuidZodValidator, zodUuidValidator} from "@vesta/global-common-typescript/validators/zodValidators";
// import {imageDetailsZodValidator, type ImageDetails} from "@vesta/janus-compatibility-module/utilities/typeDefinitions";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import FacebookPagesLogo from "~/svgs/integrationTypeLogos/facebookPagesLogo.svg?react";
import FreshsalesLogo from "~/svgs/integrationTypeLogos/freshsalesLogo.svg?react";
import GoogleAdsLogo from "~/svgs/integrationTypeLogos/googleAdsLogo.svg?react";
import GoogleAnalyticsLogo from "~/svgs/integrationTypeLogos/googleAnalyticsLogo.svg?react";
import GoogleSheetsLogo from "~/svgs/integrationTypeLogos/googleSheetsLogo.svg?react";
import InstagramLogo from "~/svgs/integrationTypeLogos/instagramLogo.svg?react";
import ShopifyLogo from "~/svgs/integrationTypeLogos/shopifyLogo.svg?react";
import YoutubeLogo from "~/svgs/integrationTypeLogos/youtubeLogo.svg?react";
import ZohoLogo from "~/svgs/landingPage/companyLogos/zoho.svg?react";
// import type {UserAccessLevel} from "~/typeDefinitions";
import type {EnumDictionary} from "~/typeDefinitions";

// export type IntellsysUser = {
//     id: Uuid;
//     // slug: string;
//     purpose: string;
//     // isDeleted: boolean;
//     // jobTitle?: string | null;
//     // department?: string | null;
// };

// export const validateProfile = zod.object({
//     user_id: zodUuidValidator,
//     name: zod.string(),
//     profile_picture_metadata: imageDetailsZodValidator.nullable().catch((context) => {
//         console.log(`Invalid logo in user: ${context.error.message}`);
//         return null;
//     }),
//     phone_number: zod.string().nullable(),
//     is_user_onboarded: zod.boolean(),
//     job_title: zod.string().optional().nullable(),
//     department: zod.string().optional().nullable(),
//     janus_id: zodUuidValidator.nullable(),
// });

// export type UserPermissionsOnCompany = {
//     accessLevel: UserAccessLevel;
// };

// export type CompanyWithUserPermissionsAndAdminCount = CompanyWithUserPermissions & {
//     adminCount?: number;
// };

// export type CompanyWithUserPermissions = Company & UserPermissionsOnCompany;

// export type Company = {
//     id: Uuid;
//     name: string;
//     domain: string;
//     website?: string;
//     primaryColor?: string;
//     logoMetadata: ImageMetadata | null;
//     logoJanusId: Uuid;
//     slug: string;
//     // TODO: Convert to proper type
//     timeZoneId: Uuid;
//     countryId: CountryId;
// };

// export type CompanyWithMemberCount = Company & {memberCount: number};

// export type ReportMetadata = {
//     id: Uuid;
//     name: string;
//     userName: string;
//     companySlug: string;
//     slug: string;
//     isPinned: boolean;
//     isFavourite: boolean;
//     // TODO: Rename this to requiredDatasetIds
//     requiredL0SkillTemplates: Array<Uuid>;
//     createdAt: Iso8601DateTime;
//     updatedAt: Iso8601DateTime;
// };

// export const reportMetadataZodValidator = zod.object({
//     id: uuidZodValidator,
//     name: zod.string(),
//     userName: zod.string(),
//     companySlug: zod.string(),
//     slug: zod.string(),
//     isPinned: zod.boolean(),
//     isFavourite: zod.boolean(),
//     requiredL0SkillTemplates: zod.array(uuidZodValidator),
//     createdAt: iso8601DateTimeZodValidator,
//     updatedAt: iso8601DateTimeZodValidator,
// });

// export type CollectionMetadata = {
//     id: Uuid;
//     name: string;
//     reportCount: number;
//     companyId: Uuid;
//     createdAt: Iso8601DateTime;
//     updatedAt: Iso8601DateTime;
//     createdBy: string;
//     slug: string;
//     description: string | null;
// };

// export type CollectionWithReportMetadata = CollectionMetadata & {
//     reports: Array<ReportMetadata>;
// };

// export type DataSourceMetadata = {
//     id: Uuid;
//     integrationType: Uuid;
// };

// export type DataSource = {
//     id: Uuid;
//     integrationType: Uuid;
//     companyId: Uuid;
//     userId: Uuid;
//     sourceCredentials: string;
//     extraInformation: string;
//     createdAt: DateTime;
//     updatedAt: DateTime;
//     lastRefreshed: DateTime;
// };

// export type Report = {
//     id: Uuid;
//     companyId: Uuid;
//     name: string;
//     pages: Array<ReportPage> | null;
//     createdBy: Uuid;
//     updatedBy: Uuid;
//     createdAt: Iso8601DateTime;
//     updatedAt: Iso8601DateTime;
//     canvasControls: CanvasControls;
//     slug: string;
//     isFavourite?: boolean | null;
//     requiredL0SkillTemplates: Array<Uuid>;
//     isPinned: boolean;
// };

// export type ReportWithUserAndCompanyName = Report & {
//     userName: string;
//     companyName: string;
// };

// export type ReportWithPermissions = Report & {accessLevel: UserAccessLevel};
// export type RecentReports = Omit<
//     ReportWithPermissions,
//     "companyName" | "isPublic" | "canvasControls"
// >;

// export type PhoneNumberWithCountryCode = string;
// export type PhoneNumberWithoutCountryCode = string;

// export enum ValueDisplayingCardInformationType {
//     integer,
//     float,
//     percentage,
//     text,
// }

// /**
//  * @deprecated Use timezone thingy from our DB instead
//  */
// export enum TimeZones {
//     UTC = "UTC",
//     IST = "Asia/Kolkata",
// }

// export enum QueryFilterType {
//     category,
//     product,
//     platform,
//     campaign,
//     date,
// }

// export function filterToTextColor(filterType: QueryFilterType) {
//     if (filterType === QueryFilterType.category) {
//         return "text-red-500";
//     } else if (filterType === QueryFilterType.product) {
//         return "text-blue-500";
//     } else if (filterType === QueryFilterType.platform) {
//         return "text-green-500";
//     } else if (filterType === QueryFilterType.campaign) {
//         return "text-purple-500";
//     } else if (filterType === QueryFilterType.date) {
//         return "text-yellow-500";
//     } else {
//         throw new Error(`Unexpected value for QueryFilterType ${filterType}`);
//     }
// }

// export function filterToHumanReadableString(filterType: QueryFilterType) {
//     if (filterType === QueryFilterType.category) {
//         return "Category";
//     } else if (filterType === QueryFilterType.product) {
//         return "Product";
//     } else if (filterType === QueryFilterType.platform) {
//         return "Platform";
//     } else if (filterType === QueryFilterType.campaign) {
//         return "Campaign";
//     } else if (filterType === QueryFilterType.date) {
//         return "Date";
//     } else {
//         throw new Error(`Unexpected value for QueryFilterType ${filterType}`);
//     }
// }

// TODO: DELETE THIS!
/**
 * @deprecated
 */
export enum IntegrationType {
    Freshsales = "3ec459aa-ecbd-4829-a89a-9d4284887a1a",
    GoogleAds = "bfd847fe-b6a5-49fa-b4dd-531c187b7f4e",
    FacebookAds = "e49978ec-5536-4473-9142-70e4d0f05ad7",
    GoogleAnalytics = "f51531c0-3d56-4b90-afc1-694009585ba7",
    Instagram = "5923da43-c397-4663-85a8-4c63f75ee458",
    Shopify = "d17f66fe-12a4-46f7-a78f-f414970a76fa",
    Youtube = "3459e9ff-90d4-49ad-8cc3-58a3798c2451",
    FacebookPage = "e93b5e01-2660-44be-9244-65d3b41d3d61",
    GoogleSheets = "886f80a2-f1db-42f6-be49-f8c7d639eb5f",
    ZohoCrm = "d4206e9e-1f8b-40f6-a433-9e3d5642e063",
    AmazonAds = "08729b0a-37d6-4329-bad7-a89702b546a6",
    AmazonMarketplaceSeller = "492d8734-5cf3-4a79-9441-91625ed06e91",
    AmazonPi = "3fc017db-e584-4f1b-af0f-9dfcbe80e5b8",
    FlipkartAds = "8434d9d9-1050-4ca5-bb4f-b2b690513e63",
    FlipkartSeller = "28b13e68-d2d1-4eff-986b-3f09611cd5c4",
    FlipkartVendor = "56cb4ba7-bd79-44f2-99e7-142ec309f0d5",
    GoogleMyBusiness = "3d70be59-1db5-4f28-aa9b-e12cc5c511e7",
}

// export enum L0SkillConnectionStrategy {
//     googleAds = "800c28ce-43ea-44b8-b6fc-077f44566296",
//     unicommerce = "240fedb1-3266-40dd-b944-3bbea897a0f7",
//     shopify = "b84a3317-7296-425a-9367-02b7dd7c3116",
//     facebookAds = "f49edd33-9426-4dba-8b62-abf2093b0a0f",
//     googleAnalytics = "c4e16b21-7052-4709-824f-c3c9cb91695b",
//     instagram = "37d758ae-f590-4d41-9578-f9ed5dbec4c6",
//     facebookPageOverviewAndPosts = "6b82a7a6-f1fc-42b7-97b0-af456c74fe98",
//     facebookPageVideoAndReels = "17ad89f2-6ec6-468b-9674-e31fc0a688f7",
//     youtube = "3bcd4c2a-45d8-49c3-b226-25433a6e783e",
//     googleSearchConsole = "f453d2d9-8cd2-4c76-b9e4-6bff42f043f1",
//     linkedinPage = "c497342c-abe5-45a9-826d-933f6271010b",
//     linkedinAds = "6b9a7eeb-4bac-456b-ab31-d5b48bc5660c",
//     amazonAds = "3a53b93b-e409-4856-aa6b-4625a4442ecc",
//     amazonMarketplaceSeller = "0bdbf703-a31a-46d1-9e41-d92e4b705cc1",
//     amazonMarketplaceVendor = "92438757-0426-4fad-944f-e16ef504ab5b",
//     custom = "bcd358fa-c7a2-4904-bc04-4c9dc9865477",
//     googleMyBusiness = "d5e9dc1f-0b0b-467d-8bbd-7b7ee25b0709",
//     flipkart = "4928d306-bc11-4c48-8ad4-7b6a32f0e737"
// }
// export const AmazonRegionUrlMap: Map<string, string> = new Map([
//     ["NA", "www"],
//     ["EU", "eu.account"],
//     ["FE", "apac.account"],
// ]);

// export const amazonSellerRegionUrlMap: Map<string, string> = new Map([
//     ["NA", "https://sellercentral.amazon.com/apps/authorize/consent"],
//     ["EU", "https://sellercentral-europe.amazon.com/apps/authorize/consent"],
//     ["FE", "https://sellercentral-fe.amazon.com/apps/authorize/consent"],
// ]);

// export const amazonVendorRegionUrlMap: Map<string, string> = new Map([
//     ["NA", "https://vendorcentral.amazon.com/apps/authorize/consent"],
//     ["EU", "https://vendorcentral-europe.amazon.com/apps/authorize/consent"],
//     ["FE", "https://vendorcentral-fe.amazon.com/apps/authorize/consent"],
// ]);

// export const amazonVendorCountryUrlMap: Map<string, string> = new Map([
//     ["Canada", "https://vendorcentral.amazon.ca/apps/authorize/consent"],
//     ["US", "https://vendorcentral.amazon.com/apps/authorize/consent"],
//     ["Mexico", "https://vendorcentral.amazon.com.mx/apps/authorize/consent"],
//     ["Brazil", "https://vendorcentral.amazon.com.br/apps/authorize/consent"],

//     ["Ireland", "https://vendorcentral.amazon.ie/apps/authorize/consent"],
//     ["Spain", "https://vendorcentral.amazon.es/apps/authorize/consent"],
//     ["UK", "https://vendorcentral.amazon.co.uk/apps/authorize/consent"],
//     ["France", "https://vendorcentral.amazon.fr/apps/authorize/consent"],
//     ["Belgium", "https://vendorcentral.amazon.com.be/apps/authorize/consent"],
//     ["Netherlands", "https://vendorcentral.amazon.nl/apps/authorize/consent"],
//     ["Germany", "https://vendorcentral.amazon.de/apps/authorize/consent"],
//     ["Italy", "https://vendorcentral.amazon.it/apps/authorize/consent"],
//     ["Sweden", "https://vendorcentral.amazon.se/apps/authorize/consent"],
//     ["South Africa", "https://vendorcentral.amazon.co.za/apps/authorize/consent"],
//     ["Poland", "https://vendorcentral.amazon.pl/apps/authorize/consent"],
//     ["Egypt", "https://vendorcentral.amazon.me/apps/authorize/consent"],
//     ["Saudi Arabia", "https://vendorcentral.amazon.me/apps/authorize/consent"],
//     ["Turkey", "https://vendorcentral.amazon.com.tr/apps/authorize/consent"],
//     ["U.A.E.", "https://vendorcentral.amazon.me/apps/authorize/consent"],

//     ["India", "https://www.vendorcentral.in/apps/authorize/consent"],
//     ["Singapore", "https://vendorcentral.amazon.com.sg/apps/authorize/consent"],
//     ["Australia", "https://vendorcentral.amazon.com.au/apps/authorize/consent"],
//     ["Japan", "https://vendorcentral.amazon.co.jp/apps/authorize/consent"],
// ]);

// export const amazonVendorCountryRegionMap: Map<string, string> = new Map([
//     // North America (NA)
//     ["Canada", "NA"],
//     ["US", "NA"],
//     ["Mexico", "NA"],
//     ["Brazil", "NA"],

//     // Europe (EU)
//     ["Ireland", "EU"],
//     ["Spain", "EU"],
//     ["UK", "EU"],
//     ["France", "EU"],
//     ["Belgium", "EU"],
//     ["Netherlands", "EU"],
//     ["Germany", "EU"],
//     ["Italy", "EU"],
//     ["Sweden", "EU"],
//     ["South Africa", "EU"],
//     ["Poland", "EU"],
//     ["Egypt", "EU"],
//     ["Saudi Arabia", "EU"],
//     ["Turkey", "EU"],
//     ["U.A.E.", "EU"],
//     ["India", "EU"],

//     // Far East (FE)
//     ["Singapore", "FE"],
//     ["Australia", "FE"],
//     ["Japan", "FE"],
// ]);

// export enum L0SkillConnectionStrategyType {
//     customLogic = "1f1f2f0f-d787-4c75-92ca-ebdd21f92806",
//     generic = "0609689e-d99b-4500-8260-1a4f525fc17f",
// }

// export type L0SkillTemplate =
//     | {
//         id: Uuid;
//         name: string;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.googleAds;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.facebookAds;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.googleAnalytics;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.googleSearchConsole;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.youtube;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.instagram;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.facebookPageOverviewAndPosts;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.facebookPageVideoAndReels;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.amazonAds;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.amazonMarketplaceSeller;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.amazonMarketplaceVendor;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.shopify;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.linkedinPage;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.linkedinAds;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.unicommerce;
//         connectionStrategyDetails: {
//             fields: L0CustomSkillTemplateFields;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: Uuid;
//         connectionStrategyDetails: {
//             fields: L0CustomSkillTemplateFields;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.generic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     }
//     | {
//         id: Uuid;
//         name: string;
//         displayName: string;
//         description: string;
//         logo: ImageDetails;
//         connectionStrategy: L0SkillConnectionStrategy.googleMyBusiness;
//         connectionStrategyDetails: {
//             scopes: string;
//         };
//         connectionStrategyType: L0SkillConnectionStrategyType.customLogic;
//         connectedAccounts: number;
//         instanceAccountDetails: Array<{
//             id: Uuid;
//             accountName: string;
//             accountId: string;
//         }>;
//     };

// export type L0CustomSkillTemplateFields = {
//     [fieldId: Uuid]: L0CustomSkillTemplateField;
// };

// export type L0CustomSkillTemplateField = {
//     id: Uuid;
//     displayName: string;
//     description: string;
//     attributeName: string;
//     attributeType: EratoDataTypes;
// };

// export enum LockStatus {
//     Locked = "LOCKED",
//     Unlocked = "UNLOCKED",
// }

// TODO: Move to a central location
export const IntegrationTypeDisplayMetadata: EnumDictionary<
    IntegrationType,
    {displayName: string; Logo: React.ComponentType<{className?: string}>}
> = {
    [IntegrationType.GoogleAds]: {
        displayName: "Google Ads",
        Logo: GoogleAdsLogo,
    },
    [IntegrationType.FacebookAds]: {
        displayName: "Facebook Ads",
        // Facebook ads and pages have same logo for now?
        Logo: FacebookPagesLogo,
    },
    [IntegrationType.GoogleAnalytics]: {
        displayName: "Google Analytics",
        Logo: GoogleAnalyticsLogo,
    },
    [IntegrationType.Instagram]: {
        displayName: "Instagram",
        Logo: InstagramLogo,
    },
    [IntegrationType.Shopify]: {
        displayName: "Shopify",
        Logo: ShopifyLogo,
    },
    [IntegrationType.Youtube]: {
        displayName: "Youtube",
        Logo: YoutubeLogo,
    },
    [IntegrationType.Freshsales]: {
        displayName: "Freshsales",
        Logo: FreshsalesLogo,
    },
    [IntegrationType.FacebookPage]: {
        displayName: "Facebook Page",
        Logo: FacebookPagesLogo,
    },
    [IntegrationType.GoogleSheets]: {
        displayName: "Google Sheet",
        Logo: GoogleSheetsLogo,
    },
    [IntegrationType.ZohoCrm]: {
        displayName: "Zoho CRM",
        Logo: ZohoLogo,
    },
    [IntegrationType.AmazonAds]: {
        displayName: "Amazon Ads",
        Logo: ZohoLogo,
    },
    [IntegrationType.AmazonPi]: {
        displayName: "Amazon Pi",
        Logo: ZohoLogo,
    },
    [IntegrationType.FlipkartAds]: {
        displayName: "Flipkart Ads",
        Logo: ZohoLogo,
    },
    [IntegrationType.FlipkartSeller]: {
        displayName: "Flipkart Seller",
        Logo: ZohoLogo,
    },
    [IntegrationType.FlipkartVendor]: {
        displayName: "Flipkart Vendor",
        Logo: ZohoLogo,
    },
};

// // export enum DatabaseIds {
// //     INTELLSYS_STORAGE1 = "06fff6bb-33b2-4c93-895c-0d94625149bf",
// //     INTELLSYS_STORAGE2 = "53e901f8-6f6e-4bae-ab85-9f4851265664",
// //     SYSTEM_DATABASE = "b3f95b31-f109-4a98-b6e1-e2ad207db136",
// // }

// export type GenericActionData = {
//     error: string | null;
// };

// export type CompanyAccessControlOnUser = UserPermissionsOnCompany & {
//     userId: Uuid;
//     companyId: Uuid;
//     userName?: string;
//     userEmail: string;
//     userProfilePicture: ImageDetails | null;
//     createdAt: Iso8601DateTime;
//     updatedAt: Iso8601DateTime;
// };

export enum NumberSystems {
    indian = "ad039db5-d6ef-458b-94dd-bf1af21f9615",
    international = "cfdded75-863e-464e-89dc-786d03add599",
    none = "5dc156aa-da04-4ca5-af5a-e7eeeed84e3f",
};
